import React, { Component } from 'react'
import Picker from './Picker';
import Welcome from './Welcome';
import Signup from './components/Signup'
import Login from './components/Login'
import Profile from './components/Profile'
import Gallery from './components/Gallery'
import Dashboard from './components/Dashboard'
import Admin from './components/Admin'
import Sidebar from './components/Ui/Sidebar'
import SidebarDesktop from './components/Ui/SidebarDesktop'
import ForgotPassword from './components/ForgotPassword'
import { withFirebase } from './components/Firebase';
import '../css/App.css';
import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route
} from "react-router-dom";

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            authUser: null,
            currentReference: 0,
            references: [
                'images/bouguero.jpg',
                'images/classic.jpg'
            ]
        };

        this.changeReference = this.changeReference.bind(this);
        this.addReference = this.addReference.bind(this);
    }

    componentDidMount() {
        this.listener = this.props.firebase.auth.onAuthStateChanged(authUser => {
            authUser
                ? this.setState({ authUser })
                : this.setState({ authUser: null });
        });
    }

    /**
     * Changes Current Reference Index
     * @param {int} index this.state.references[index]
     */
    changeReference(index) {
        this.setState({currentReference: index});
    }

    addReference(imageBase) {
        this.setState({
            references: [...this.state.references, imageBase]
        });
    }

    componentWillUnmount() {
        this.listener();
    }

    render() {
        return (
            <Router>
                <div className="h-screen flex overflow-hidden bg-white">
                    <Switch>
                        <Route path="/picker">
                            <Sidebar authUser={this.state.authUser} />
                            <SidebarDesktop authUser={this.state.authUser} />
                        </Route>
                        <Route path="/profile">
                            <Sidebar authUser={this.state.authUser} />
                            <SidebarDesktop authUser={this.state.authUser} />
                        </Route>
                        <Route path="/gallery">
                            <Sidebar authUser={this.state.authUser} />
                            <SidebarDesktop authUser={this.state.authUser} />
                        </Route>
                        <Route path="/dashboard">
                            <Sidebar authUser={this.state.authUser} />
                            <SidebarDesktop authUser={this.state.authUser} />
                        </Route>
                        <Route path="/admin">
                            <Sidebar authUser={this.state.authUser} />
                            <SidebarDesktop authUser={this.state.authUser} />
                        </Route>
                    </Switch>

                    <div className="flex flex-col w-0 flex-1 bg-gray-100 overflow-hidden">
                        <div className="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
                            <button className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150" aria-label="Open sidebar">
                                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        </div>
                        <main className="flex-1 relative z-0 overflow-y-auto pt-2 focus:outline-none md:pt-6" tabIndex="0">
                            {/*<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
                            </div>*/}
                            { this.state.authUser ? (
                                <Switch>
                                    <Route path="/picker">
                                        <Picker image={this.state.references[this.state.currentReference]} />
                                    </Route>
                                    <Route path="/gallery">
                                        <Gallery addReference={this.addReference} changeReference={this.changeReference} references={this.state.references} />
                                    </Route>
                                    <Route path="/signup">
                                        <Redirect to="/dashboard" />
                                    </Route>
                                    <Route path="/login">
                                        <Redirect to="/dashboard" />
                                    </Route>
                                    <Route path="/forgot-password">
                                        <Redirect to="/profile" />
                                    </Route>
                                    <Route path="/profile">
                                        <Profile />
                                    </Route>
                                    <Route path="/dashboard">
                                        <Dashboard />
                                    </Route>
                                    <Route path="/admin">
                                        <Admin />
                                    </Route>
                                    <Route path="/">
                                        <Welcome />
                                    </Route>
                                </Switch>
                            ) : (
                                <Switch>
                                    <Route path="/picker">
                                        <Redirect to="/login" />
                                    </Route>
                                    <Route path="/gallery">
                                        <Redirect to="/login" />
                                    </Route>
                                    <Route path="/signup">
                                        <Signup />
                                    </Route>
                                    <Route path="/login">
                                        <Login />
                                    </Route>
                                    <Route path="/forgot-password">
                                        <ForgotPassword />
                                    </Route>
                                    <Route path="/profile">
                                        <Redirect to="/login" />
                                    </Route>
                                    <Route path="/dashboard">
                                        <Redirect to="/login" />
                                    </Route>
                                    <Route path="/">
                                        <Welcome />
                                    </Route>
                                </Switch>
                            )}
                        </main>
                    </div>
                </div>
            </Router>
        );
    }
}

export default withFirebase(App);
